const PREFIX = 'insurance-result:'

// 结果按本次流程单独保存；地址仅携带索引，不暴露保单信息，刷新结果页仍可回显。
export function saveInsuranceResult(result) {
  const key = Date.now().toString(36) + Math.random().toString(36).slice(2)
  const { productName, productCode, policyNo, status, failMsg } = result
  sessionStorage.setItem(
    PREFIX + key,
    JSON.stringify({ productName, productCode, policyNo, status, failMsg })
  )
  return key
}

export function readInsuranceResult(key) {
  if (!key) return null
  try {
    return JSON.parse(sessionStorage.getItem(PREFIX + key) || 'null')
  } catch (error) {
    return null
  }
}
